import { telaSobDemanda, type TelaRotina } from '../tipoTelaRotina';

export const telasEST: Record<string, TelaRotina> = {
  'est/painel': telaSobDemanda(() => import('../../../modulos/EST/PainelEstoque'), 'PainelEstoque'),
  'est/reposicao': telaSobDemanda(() => import('../../../modulos/EST/PaginaReposicao'), 'PaginaReposicao'),
  'est/recalculo-custo': telaSobDemanda(() => import('../../../modulos/EST/PaginaRecalculoCusto'), 'PaginaRecalculoCusto'),
  'est/recalculo-saldo': telaSobDemanda(() => import('../../../modulos/EST/PaginaRecalculoSaldo'), 'PaginaRecalculoSaldo'),
};
